import { useState } from 'react';
import { SECTIONS } from '../Constants';

// eslint-disable-next-line import/prefer-default-export
export function useCheckboxes() {
  const [selectAll, setSelectAll] = useState(false);

  const [checkedItems, setCheckedItems] = useState<
        Record<string, Record<string, boolean>>
    >({
      [SECTIONS.ITERATION_DETAILS]: {},
      [SECTIONS.COHORTS]: {},
      [SECTIONS.ROUTING_PLAN_IDS]: {},
      [SECTIONS.FILTER_RULES]: {},
      [SECTIONS.SUPPRESSION_RULES]: {},
      [SECTIONS.ROUTING_RULES]: {},
    });

  const [sectionCheckboxes, setSectionCheckboxes] = useState<
        Record<string, boolean>
    >({
      [SECTIONS.ITERATION_DETAILS]: false,
      [SECTIONS.COHORTS]: false,
      [SECTIONS.ROUTING_PLAN_IDS]: false,
      [SECTIONS.FILTER_RULES]: false,
      [SECTIONS.SUPPRESSION_RULES]: false,
      [SECTIONS.ROUTING_RULES]: false,
    });

  const updateCheckboxItem = (section: string, id: string) => {
    setCheckedItems((prev) => {
      const currentValue = prev[section][id];

      return {
        ...prev,
        [section]: {
          ...prev[section],
          [id]: !currentValue,
        },
      };
    });

    setSelectAll(false);
    setSectionCheckboxes((prev) => ({
      ...prev,
      [section]: false,
    }));
  };

  const updateCheckboxItemsForSection = (section: string, id: string) => {
    setCheckedItems((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [id]: !prev[section][id],
      },
    }));
  };

  const updateCheckedBoxItemsForSection = (
    sectionKey: string,
    isChecked: boolean,
  ) => {
    setCheckedItems((prev) => ({
      ...prev,
      [sectionKey]: Object.fromEntries(
        Object.keys(prev[sectionKey] || {}).map((key) => [
          key,
          isChecked,
        ]),
      ),
    }));
  };

  const updateSectionCheckboxItem = (section: string) => {
    const isChecked = !sectionCheckboxes[section];

    setSectionCheckboxes((prev) => ({
      ...prev,
      [section]: isChecked,
    }));

    updateCheckedBoxItemsForSection(section, isChecked);

    setSelectAll(false);
  };

  const updateAllCheckboxItems = (isChecked: boolean) => {
    updateCheckedBoxItemsForSection(SECTIONS.ITERATION_DETAILS, isChecked);
    updateCheckedBoxItemsForSection(SECTIONS.COHORTS, isChecked);
    updateCheckedBoxItemsForSection(SECTIONS.ROUTING_PLAN_IDS, isChecked);
    updateCheckedBoxItemsForSection(SECTIONS.FILTER_RULES, isChecked);
    updateCheckedBoxItemsForSection(SECTIONS.SUPPRESSION_RULES, isChecked);
    updateCheckedBoxItemsForSection(SECTIONS.ROUTING_RULES, isChecked);
    setSelectAll(isChecked);
  };

  return {
    selectAll,
    checkedItems,
    sectionCheckboxes,
    setSectionCheckboxes,
    updateCheckboxItem,
    updateCheckboxItemsForSection,
    updateCheckedBoxItemsForSection,
    updateAllCheckboxItems,
    updateSectionCheckboxItem,
  };
}
